import qahoy from "views_shared/app/javascript/scripts/qahoy";
import qapi from "views_shared/app/javascript/api";

// Media outlet update hook — mirrors use_media_profile_update_api: instantiated by an edit-modal body
// from the provider context's setters, exposes updateMediaOutlet(data).
//
// updateById throws (throwOnApiError) on failure, so reaching the code after it means the save
// landed. A failure is caught here and surfaced via generalError — the modal-local alert that keeps
// the modal open. We deliberately do NOT use asyncError for a save failure: asyncError is re-thrown
// to the page error boundary, which would tear down the whole page for a recoverable, retryable
// save error.
//
// The controller renames and then writes the remaining attributes, so a failure can leave a partial
// save behind. The failure path therefore re-syncs page state from the server rather than assuming
// nothing changed; the reload is guarded so a backend that is down cannot leak an unhandled
// rejection out of the submit handler.
const useMediaOutletUpdateApi = ({ mediaOutletId, setIsUpdating, setGeneralError, setOpenEditModal, silentReload }) => {
  const updateMediaOutlet = async (data, options = {}) => {
    const { closeModal = true } = options;

    try {
      setIsUpdating(true);
      setGeneralError(null);

      qahoy.track("MediaOutlets#updateMediaOutlet");

      await qapi.mediaOutlets.updateById(mediaOutletId, data);

      if (closeModal) setOpenEditModal(null);
      await silentReload();
    } catch (error) {
      setGeneralError(error);
      try {
        await silentReload();
      } catch {
        // The generalError already tells the user the save failed; a rejecting reconcile reload must
        // never propagate an unhandled rejection out of the submit handler.
      }
    } finally {
      setIsUpdating(false);
    }
  };

  return { updateMediaOutlet };
};

export default useMediaOutletUpdateApi;
